module.exports = __webpack_public_path__ + "static/media/huli_302.2a78acd1.gif";